import styled from 'styled-components';

export const StyledInlineEditableText = styled.div`
  display: inline-block;
  position: relative;

  .editable-text-display {
    padding: 0.5rem 0.75rem;
    border: 1px solid transparent;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    background-color: transparent;
    min-width: 200px;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;

    &:hover:not(.disabled) {
      border-color: #ced4da;
      background-color: #f8f9fa;
    }

    &.disabled {
      cursor: default;
    }

    &.editing {
      display: none;
    }
  }

  .editable-text-input {
    display: none;
    min-width: 200px;

    &.editing {
      display: block;
    }
  }
`;
